<template>

</template>

<script>
    export default {
        name: 'RemindPassword'
    }
</script>


// WEBPACK FOOTER //
// RemindPassword.vue?074c3630